export default "__VITE_ASSET__15d87f66__"